import { SORT_DIRECTIONS } from 'constants/sortDirectionsEnum';

export enum TABLE_COLUMNS {
  EVENT = 'Event',
  DETAILS = 'Details',
  SOURCES = 'Sources',
  CREATED_AT = 'CreatedAt',
  OVERFLOW_MENU = 'OverflowMenu',
}

export const DEFAULT_SORTED_TABLE_COLUMN = TABLE_COLUMNS.CREATED_AT;
export const DEFAULT_SORT_DIRECTION = SORT_DIRECTIONS.DESCENDING;
export const ORDERED_TABLE_COLUMNS = [
  TABLE_COLUMNS.EVENT,
  TABLE_COLUMNS.DETAILS,
  TABLE_COLUMNS.SOURCES,
  TABLE_COLUMNS.CREATED_AT,
  TABLE_COLUMNS.OVERFLOW_MENU,
];
export const SORTABLE_TABLE_COLUMN_FIELD_MAPPING: Record<string, string> = {
  [TABLE_COLUMNS.EVENT]: '_type',
  [TABLE_COLUMNS.CREATED_AT]: 'createdAt',
};

export const TABLE_COLUMN_WIDTHS = {
  [TABLE_COLUMNS.EVENT]: '1.5fr',
  [TABLE_COLUMNS.DETAILS]: '1.75fr',
  [TABLE_COLUMNS.SOURCES]: '1fr',
  [TABLE_COLUMNS.CREATED_AT]: '1fr',
  [TABLE_COLUMNS.OVERFLOW_MENU]: 'min-content',
};

export const SEARCH_PARAM_KEYS = {
  eventType: 'eventType',
  browser: 'browser',
  operatingSystem: 'operatingSystem',
  device: 'device',
  search: 'search',
};

export enum FILTERS {
  EVENT_TYPE = 'eventType',
  BROWSER = 'browser',
  OPERATING_SYSTEM = 'operatingSystem',
  DEVICE = 'device',
}

export const FILTER_NAMES = {
  [FILTERS.EVENT_TYPE]: 'Event type',
  [FILTERS.BROWSER]: 'Browser',
  [FILTERS.OPERATING_SYSTEM]: 'Operating system',
  [FILTERS.DEVICE]: 'Device',
};

export const HIDDEN_BY_GMAIL = 'Hidden by Gmail';
export const UNKNOWN = 'Unknown';

export const USER_AGENT_FILTER_DISPLAY_NAMES: Record<string, string> = {
  undefined: 'Unknown',
};

export const MENU_ID_DELIMITER = '--';

export enum ENTITIES {
  CHANNEL = 'Channel',
  MESSAGETYPE = 'MessageType',
  LIST = 'List',
}

export const AGGREGATE_ENTITIES = {
  [ENTITIES.CHANNEL]: 'channels',
  [ENTITIES.MESSAGETYPE]: 'message types',
  [ENTITIES.LIST]: 'lists',
};
